import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-header__title"
}

import { type PropType } from 'vue';

import { modalType, type ModalType, modalVariant, type ModalVariant } from './modal-type-validators';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalHeader',
  props: {
  title: String,
  canClose: { type: Boolean, default: true },
  type: { type: String as PropType<ModalType>, default: modalType.base },
  variant: { type: String as PropType<ModalVariant>, default: modalVariant.light },
},
  emits: ["closed"],
  setup(__props, { emit: __emit }) {


const emit = __emit;

const close = () => {
  emit('closed');
};

return (_ctx: any,_cache: any) => {
  const _component_ot_icon = _resolveComponent("ot-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['modal-header', `modal-header--${__props.type}`, `modal-header--${__props.variant}`, { 'modal-header--closable': __props.canClose }])
  }, [
    (__props.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.title), 1))
      : _renderSlot(_ctx.$slots, "default", { key: 1 }),
    (__props.canClose)
      ? (_openBlock(), _createElementBlock("button", {
          key: 2,
          class: "modal-header__close",
          onClick: close
        }, [
          _createVNode(_component_ot_icon, {
            class: "modal-header__close-icon",
            name: "close",
            "inherit-stroke": "inherit-stroke"
          })
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})